import type { MeetingAttendanceStatus } from '@repo/types/meetings';

import { Tabs, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/ui/tooltip';

interface MeetingAttendanceTogglesProps {
  status: MeetingAttendanceStatus | null;
  userId: number;
  onValueChange: (value: MeetingAttendanceStatus, id: number) => void;
}

const STATUSES: MeetingAttendanceStatus[] = ['present', 'absent', 'late'];

function isAttendanceStatus(value: string): value is MeetingAttendanceStatus {
  return STATUSES.some((status) => status === value);
}

export default function MeetingAttendanceToggles(meetingAttendanceTogglesProps: MeetingAttendanceTogglesProps) {
  const { status, userId, onValueChange } = meetingAttendanceTogglesProps;

  const handleValueChange = (value: string) => {
    if (!isAttendanceStatus(value)) return;
    onValueChange(value, userId);
  };

  return (
    <Tabs value={status ?? ''} onValueChange={handleValueChange} className={'shrink-0'}>
      <TabsList className={'trnasition-all grid grid-cols-3'}>
        <Tooltip>
          <TabsTrigger asChild className={'data-[state=active]:bg-success-accent data-[state=active]:text-success h-7 w-7 cursor-pointer border-0 px-2'} value={'present'}>
            <TooltipTrigger>O</TooltipTrigger>
          </TabsTrigger>

          <TooltipContent>Obecny</TooltipContent>
        </Tooltip>
        <Tooltip>
          <TabsTrigger asChild className={'data-[state=active]:bg-warning-accent data-[state=active]:text-warning h-7 w-7 cursor-pointer border-0 px-2'} value={'late'}>
            <TooltipTrigger>S</TooltipTrigger>
          </TabsTrigger>

          <TooltipContent>Spóźniony</TooltipContent>
        </Tooltip>
        <Tooltip>
          <TabsTrigger asChild className={'data-[state=active]:bg-destructive-accent data-[state=active]:text-destructive h-7 w-7 cursor-pointer border-0 px-2'} value={'absent'}>
            <TooltipTrigger>N</TooltipTrigger>
          </TabsTrigger>

          <TooltipContent>Nieobecny</TooltipContent>
        </Tooltip>
      </TabsList>
    </Tabs>
  );
}
